import { render, staticRenderFns } from "./SelectPayMethod.vue?vue&type=template&id=2e59677c&scoped=true&"
import script from "./SelectPayMethod.vue?vue&type=script&lang=js&"
export * from "./SelectPayMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e59677c",
  null
  
)

export default component.exports